import type { Study } from 'content/science/studyTypes';

/* The subset these helpers read. Widened from `Study` so a thinner
   related-studies card can reuse the same href logic. */
export type StudyLike = Pick<Study, 'kind' | 'slug'> &
  Partial<Pick<Study, 'externalUrl' | 'venue'>>;

/* Where a study row links to. White papers have detail pages here;
   publications go to their external journal URL.
 *
 * A snapshot resolves to the LISTING. Not `/science/bytes/<slug>` — that route
 * is retired and every byte URL now redirects to its /science/ask/ successor.
 * Not `/science/studies/<slug>` either: that route notFound()s a snapshot, so
 * the upstream fall-through handed snapshots a 404. No caller passes one today
 * (both filter snapshots out) and the branch is here so that stays true by
 * construction rather than by luck. */
export const hrefFor = (s: StudyLike): string => {
  if (s.kind === 'snapshot') return '/science/studies/';
  if (s.kind === 'white-paper') return `/science/studies/${s.slug}`;
  return s.externalUrl || `/science/studies/${s.slug}`;
};

export const isExternalLink = (s: StudyLike): boolean =>
  s.kind !== 'snapshot' && s.kind !== 'white-paper' && Boolean(s.externalUrl);
